"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityStatusTypes = {
    createNew: 0,
    scheduled: 1,
    completed: 2,
    uncompleted: 3
};
